import { Select } from "antd";
import React, { useEffect, useState } from "react";
import MemoryType from "../../../service/memory/enum/MemoryType";
import apiService from "../../../service/apiservice/apiService";
import { useReadMemory } from "../../generic/hooks/useReadMemory";

const SelectOrganization = ({
  selectedOrganization,
  setSelectedOrganization,
}) => {
  const userData = useReadMemory(MemoryType.USER);
  const [organizations, setOrganizations] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchOrganizations = async () => {
      setLoading(true);
      const endpoint = "niramayafoundation/api/v1/organization";
      const params = {
        searchQuery: "",
      };

      try {
        const response = await apiService.get(endpoint, params);
        const sortedData = Array.isArray(response)
          ? [...response].sort((a, b) => {
              if (a.id.toString() === userData?.organizationIdentifier) return -1;
              if (b.id.toString() === userData?.organizationIdentifier) return 1;
              return 0;
            })
          : [];
        setOrganizations(sortedData);
      } finally {
        setLoading(false);
      }
    };

    fetchOrganizations();
  }, [userData?.organizationIdentifier]);

  return (
    <div className="organization-select-wrapper">
      <div className="event-type-label">Organization:</div>
      <Select
        allowClear
        showSearch
        loading={loading}
        className="audit-log-organization-select"
        placeholder="All organizations"
        value={selectedOrganization}
        onChange={setSelectedOrganization}
        optionFilterProp="label"
        options={organizations.map((organization) => ({
          label: organization?.name,
          value: organization?.id?.toString(),
        }))}
      />
    </div>
  );
};

export default SelectOrganization;
